import { render, staticRenderFns } from "./payHeader.vue?vue&type=template&id=28e562a2&scoped=true&"
import script from "./payHeader.vue?vue&type=script&lang=ts&"
export * from "./payHeader.vue?vue&type=script&lang=ts&"
import style0 from "./payHeader.vue?vue&type=style&index=0&id=28e562a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e562a2",
  null
  
)

export default component.exports